module.exports = __webpack_public_path__ + "static/media/addCard.f17efd62.png";